import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'owners',
    label: 'Choose Borrower',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'type',
    label: 'Liability Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'companyName',
    label: 'Creditor Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'typeOfCredit',
    label: 'Type of credit',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanType',
    label: 'Type of Loan',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'accountNumber',
    label: 'Account Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'existingCaseNumber',
    label: 'Existing Case #',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'existingLienUpfrontMip',
    label: 'Existing Lien Upfront MIP',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'existingLienInterestAmount',
    label: 'Existing Lien Interest Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hudAuthorizationCode',
    label: 'HUD Authorization Code',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sourceOfFunds',
    label: 'Source Of Funds',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherFundDescription',
    label: 'Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthsDeferred',
    label: 'Months Deferred',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lienPriorityType',
    label: 'Lien Priority',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unpaidBalance',
    label: 'Unpaid Balance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyPayment',
    label: 'Monthly Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'highLimit',
    label: 'High Limit',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthsRemaining',
    label: 'Remaining Months',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'property',
    label: 'Property Address',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dateOpened',
    label: 'Open Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'toBePaidOffAtOrBeforeClosing',
    label: 'Pay Off',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'excludePayment',
    label: 'Exclude Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'paymentExclusionReason',
    label: 'Exclusion Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'paymentExclusionReasonOtherDescription',
    label: 'Other Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isSubordinate',
    label: 'Subordinate',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'heloc',
    label: 'HELOC',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'qualifiedNonCashOut',
    label: 'Non Cash Out',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isAffordableLoan',
    label: 'Affordable Loan',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isOriginalLenderRefinance',
    label: 'Original Lender Refinance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'closingCosts',
    label: 'Closing Costs',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicingContactName',
    label: 'Servicing Contact Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'servicingContactPhoneNumber',
    label: 'Servicing Contact Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'originalPropertyValue',
    label: 'Original Property Value',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanMipFactor',
    label: 'Loan MIP Factor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'endorsementDate',
    label: 'Endorsement Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'originalEndorsementDate',
    label: 'Original Endorsement Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unearnedMipFactor',
    label: 'Unearned MIP Factor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unearnedMip',
    label: 'Unearned MIP',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'earnedMip',
    label: 'Earned MIP',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const liabilitiesForm = {
  name: FormNames.LIABILITIES,
  label: 'Liabilities',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
